function QRSection() {
    return (
        <section className="flex grow items-stretch mb-9 w-[80%] md:w-full md:gap-[40px_75px] flex-wrap md:max-w-full md:mt-10">
            <div className="aspect-[0] object-contain md:w-px shrink-0 bg-gray-300" />
            <div className="flex flex-col items-stretch grow shrink-0 basis-0 w-fit mt-[45px] md:max-w-full max-md:mt-10 max-md:text-center">
                <h2 className="text-[#58585E] text-lg font-bold mr-[60px] max-md:mr-2.5 max-md:text-center">
                    Escanea el QR y vincula tu dispositivo
                </h2>
                <div className="mt-[77px] max-md:max-w-full max-md:mt-10">
                    <div className="gap-5 flex max-md:flex-col max-md:items-stretch">
                        <div className="w-6/12 max-md:w-full max-md:ml-0">
                            <div className="flex flex-col self-stretch items-stretch text-sm text-[#58585E] font-medium my-auto max-md:mt-10 max-md:text-center">
                                <p className="mb-[45px] max-md:mb-10">Abre WhatsApp en tu teléfono</p>
                                <p className="md:w-[260px] mb-[42px] max-md:mr-[3px] max-md:mb-10">
                                    Ir a{' '}
                                    <span className="font-bold text-[15px] leading-[18px]">Menú o Configuración</span>
                                    {' > Dispositivos vinculados > Vincular un dispositivo'}
                                </p>
                                <p>
                                    Apunta tu teléfono hacia esta pantalla y{' '}
                                    <span className="font-bold text-[15px] leading-[18px]">escanea el código QR</span>
                                </p>
                            </div>
                        </div>
                        <div className="w-[100%] mr-[15%] sm:items-center md:w-full md:ml-0  max-md:justify-center">
                            <img src="https://api.builder.io/api/v1/image/assets/TEMP/26e0dbc43aca3ad4232a4907da98445e8db34558?placeholderIfAbsent=true"
                                alt="QR Code for WhatsApp connection" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default QRSection;
